module.exports = __webpack_public_path__ + "img/slider1new.d1ab6293.png";